import isEqual from 'lodash/isEqual';
import {
  RECEIVE_DATA,
  INVALIDATE_CACHE,
  REQUEST_DATA,
  STAGE_WHAT_IFS,
  SET_UPDATE_CACHE_DATA,
  FAILED_TO_RECEIVE_DATA,
  REQUEST_ABORTED,
} from './MonteCarloChartActions';
import { MESSAGES } from '../CommonConstants';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  const { type, clientId, requestedWith, whatIfs, data, updateCacheData } = action;

  switch (type) {
    case REQUEST_DATA: {
      return {
        ...state,
        [clientId]: {
          ...(state[clientId] || {}),
          requestedWith,
          loading: ((state[clientId] || {}).loading || 0) + 1,
          error: null,
        },
      };
    }

    case INVALIDATE_CACHE:
      return {
        ...state,
        [clientId]: {
          ...(state[clientId] || {}),
          requestedWith: null,
          stagedWhatIfs: null,
        },
      };

    case STAGE_WHAT_IFS:
      return {
        ...state,
        [clientId]: {
          ...(state[clientId] || {}),
          stagedWhatIfs: whatIfs,
        },
      };

    case RECEIVE_DATA: {
      const clientState = state[clientId] || {};
      const loading = Math.max((clientState.loading || 1) - 1, 0);
      const hasError = Boolean(clientState.error);
      // Only commit the payload if it belongs to the client's current request.
      // A superseded response (e.g. a base GET that resolves after a staged
      // what-if POST) no longer matches requestedWith and is ignored, so it
      // cannot overwrite the latest result regardless of completion order.
      const isCurrent = isEqual(requestedWith, clientState.requestedWith);
      return {
        ...state,
        [clientId]: {
          ...clientState,
          responseData: isCurrent && !hasError ? data : clientState.responseData,
          loading,
          error: clientState.error || null,
        },
      };
    }

    case SET_UPDATE_CACHE_DATA:
      return {
        ...state,
        [clientId]: {
          ...(state[clientId] || {}),
          updateCacheData,
        },
      };

    case REQUEST_ABORTED: {
      const clientState = state[clientId] || {};
      const loading = Math.max((clientState.loading || 1) - 1, 0);
      return {
        ...state,
        [clientId]: {
          ...clientState,
          loading,
          // The aborted request delivered no data. When nothing else is in
          // flight (loading === 0), clear requestedWith so a remount's
          // loadIfNecessary sees a mismatch and refetches instead of treating
          // the aborted attempt as satisfied. If loading > 0, a newer request
          // already set requestedWith, so leave it intact.
          requestedWith: loading === 0 ? null : clientState.requestedWith,
        },
      };
    }

    case FAILED_TO_RECEIVE_DATA: {
      const clientState = state[clientId] || {};
      const loading = Math.max((clientState.loading || 1) - 1, 0);
      // Only surface the error if the failed request is still the client's
      // current one. A superseded fetch (e.g. a base GET that fails after a
      // staged what-if POST has already succeeded) no longer matches
      // requestedWith and must not overwrite the valid result with an error.
      const isCurrent = isEqual(requestedWith, clientState.requestedWith);
      return {
        ...state,
        [clientId]: {
          ...clientState,
          loading,
          error: isCurrent ? MESSAGES.GENERIC_ERROR : clientState.error || null,
        },
      };
    }

    default:
      return state;
  }
};
